import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { AVERAGE_RATING, NUMBER_OF_REVIEWS } from '../../constants';
import styles from './ReviewAggregate.module.scss';
import Icon from '../IconDS22';

const ReviewAggregate: FC = () => {
  const [t] = useTranslation('common');

  return (
    <div className={styles.root}>
      <h4 className={styles.title}>
        {t('review-aggregate--title')}
      </h4>
      <p className={styles.subtitle}>
        <Icon id="star-filled" size="s" />
        {AVERAGE_RATING}
        {' '}
        {t('review-aggregate--out-of')}
        {' '}
        {NUMBER_OF_REVIEWS.toLocaleString()}
        {t('review-aggregate--reviews')}
      </p>
    </div>
  );
};
export default ReviewAggregate;
